import { Checkbox, Divider, Link, Typography } from "@volvo/vcdk-react";
import { UITEXT } from "../../../../constants/const";
import NavigationButtons from "../NavigationButtons/NavigationButtons";
import type { DataSharingAgreementTabProps } from "../types";
import styles from "./DataSharingAgreementTab.module.css";

const DataSharingAgreementTab: React.FC<DataSharingAgreementTabProps> = ({
    formData,
    handleCheckboxChange,
    onSubmit,
    onBack,
    errors,
    submitError,
    isSubmitDisabled,
}) => (
    <div className={styles.Section}>
        <Typography variant="caption1">
            {UITEXT.DataSharingAgreement.Notice}
        </Typography>
        <Divider />
        <div className={styles.RequesterInformationTextSection}>
            <div>
                <Checkbox
                    name="dataSharingAgreementDSA"
                    className={styles.Checkbox}
                    size="small"
                    label={UITEXT.DataSharingAgreement.DSA}
                    checked={formData.dataSharingAgreementDSA}
                    onChange={handleCheckboxChange}
                />

                <div className={styles.ErrorWrapper}>
                    {errors && errors.dataSharingAgreementDSA && (
                        <Typography
                            variant="caption2"
                            className={styles.ErrorMessage}
                        >
                            {errors.dataSharingAgreementDSA}
                        </Typography>
                    )}
                </div>
                <div
                    style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                    <Link
                        variant="standalone"
                        href={UITEXT.DataSharingAgreement.DSARTLink}
                        target="_blank"
                        icon="link-external"
                    >
                        {UITEXT.DataSharingAgreement.DSARTName}
                    </Link>
                    <Link
                        variant="standalone"
                        href={UITEXT.DataSharingAgreement.DSAVBLink}
                        target="_blank"
                        icon="link-external"
                    >
                        {UITEXT.DataSharingAgreement.DSAVBName}
                    </Link>
                    <Link
                        variant="standalone"
                        href={UITEXT.DataSharingAgreement.DSAVTLink}
                        target="_blank"
                        icon="link-external"
                    >
                        {UITEXT.DataSharingAgreement.DSAVTName}
                    </Link>
                    <Link
                        variant="standalone"
                        href={UITEXT.DataSharingAgreement.DSAVELink}
                        target="_blank"
                        icon="link-external"
                    >
                        {UITEXT.DataSharingAgreement.DSAVEName}
                    </Link>
                </div>
            </div>
            <Divider />
            <div>
                <Checkbox
                    name="dataSharingAgreementVG"
                    className={styles.Checkbox}
                    size="small"
                    label={UITEXT.DataSharingAgreement.VG}
                    checked={formData.dataSharingAgreementVG}
                    onChange={handleCheckboxChange}
                />
                <div className={styles.ErrorWrapper}>
                    {errors && errors.dataSharingAgreementVG && (
                        <Typography
                            variant="caption2"
                            className={styles.ErrorMessage}
                        >
                            {errors.dataSharingAgreementVG}
                        </Typography>
                    )}
                </div>
            </div>
            <Divider />
            <div>
                <Checkbox
                    name="dataSharingAgreementGDPR"
                    className={styles.Checkbox}
                    size="small"
                    label={UITEXT.DataSharingAgreement.GDPR}
                    checked={formData.dataSharingAgreementGDPR}
                    onChange={handleCheckboxChange}
                />
                <div className={styles.ErrorWrapper}>
                    {errors && errors.dataSharingAgreementGDPR && (
                        <Typography
                            variant="caption2"
                            className={styles.ErrorMessage}
                        >
                            {errors.dataSharingAgreementGDPR}
                        </Typography>
                    )}
                </div>
            </div>
        </div>
        <Divider />
        <NavigationButtons
            onBack={onBack}
            onSubmit={onSubmit}
            isSubmitDisabled={isSubmitDisabled}
        />
        {isSubmitDisabled && (
            <div className={styles.ErrorWrapper}>
                <Typography variant="caption2" className={styles.ErrorMessage}>
                    Submit disabled: Wait until all attachments finish uploading
                    or retry failed ones.
                </Typography>
            </div>
        )}
        {submitError && (
            <div className={styles.ErrorWrapper}>
                <Typography variant="caption2" className={styles.ErrorMessage}>
                    {submitError}
                </Typography>
            </div>
        )}
    </div>
);

export default DataSharingAgreementTab;
